import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

function MonthlyImports({foodAnswers, foodName}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let monthlyImport = foodAnswers.answerKeyValues['monthly_us_import_data'];
	let monthlyImportYear = foodAnswers.answerKeyValues['monthly_us_import_data_year'];
	let monthlyImportSourceRef = foodAnswers.answerKeyValues['monthly_us_import_data_sources'];
	let monthlyImportNotes = foodAnswers.answerKeyValues['monthly_us_import_data_notes'];
	let monthlyImportNarrative = foodAnswers.answerKeyValues['monthly_us_import_data_narrative'];
	let monthlyImportUnit = foodAnswers.answerKeyValues['monthly_us_import_data_unit'] || "Metric Tons";
	
	let array = [];
	let dataSeries = [];
	let seriesObj = {};
	let monthValues = [];
	const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
	if (monthlyImport) {
		try {
			array = JSON.parse(monthlyImport);
		} catch (err) {
			console.log("MonthlyImports :monthlyImport: " + err);
		}
		array.map((obj) => {
			if (obj && obj["year"]) {
				monthValues = [];
				seriesObj = {};
				seriesObj["name"] = obj.year;
				months.map(function(month) {
					if(obj[month.toLowerCase()]){
						monthValues.push(parseFloat(obj[month.toLowerCase()].replace(/,/g, '')));
					}
					
				})
				seriesObj["data"] = monthValues;
				dataSeries.push(seriesObj);
			}
		})
	}
	let titleText = '';
	if(dataSeries && dataSeries.length > 0){
		titleText = 'Monthly Imports of '+foodName+' into the United States';
	}
	
	return(
			<div>
				{(dataSeries && dataSeries.length > 0) ? <><h2 style={{textAlign: "center"}}>
					{titleText}
					{monthlyImportYear ? 
					<small>&nbsp;({monthlyImportYear})</small>
					: ""}
					{ monthlyImportSourceRef && monthlyImportSourceRef > 0 ?
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+monthlyImportSourceRef}>{monthlyImportSourceRef}</a></small>:
					""	
					}
				</h2>
				<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
				options={{
					title: {
						text: ''
					},
					credits: {
						enabled: false
					},
					lang: {
						thousandsSep: ','
					},
					yAxis: {
						title: {
							text: monthlyImportUnit
						},
						plotLines: [{
							value: 0,
							width: 1,
							color: '#808080'
						}]
					},
					legend: {
						layout: 'horizontal',
						align: 'center',
						verticalAlign: 'bottom',
						y: -10
					},
					xAxis: {
						categories: months
					},
					series: dataSeries
				}}
				/>
				{monthlyImportNarrative  ? 
				<p>{monthlyImportNarrative}</p>
				:""}
				{monthlyImportNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{monthlyImportNotes}</em>
				</p>
				:""}
				</>:""}
			</div>
		)
}
export default MonthlyImports;